import { isTesting, macroCondition } from '@embroider/macros';

export default function getDelayTime(time) {
  if (macroCondition(isTesting())) {
    return 1;
  } else {
    return time;
  }
}
